window.Vue = require('vue');



// WEBPACK FOOTER //
// ./resources/js/app/components/vue-declarator.js